import {
    IPluginUseCase,
    IPluginNotificationSendDto,
    IPluginNotificationSendResultDto,
    IPluginCommunicationSendMessageDto,
    IPluginCommunicationSendMessageResult,
} from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class PluginUseCase implements IPluginUseCase {
    public async notificationSend(
        companyId: string,
        bindingId: string,
        dto: IPluginNotificationSendDto,
    ): Promise<IPluginNotificationSendResultDto> {
        try {
            const response = await Api.post<IPluginNotificationSendResultDto>(
                `/companies/${companyId}/plugins/${bindingId}/notification/send`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    // public async notificationCost(
    //     companyId: string,
    //     bindingId: string,
    //     dto: IPluginNotificationSendDto,
    // ): Promise<IPluginNotificationSendResultDto> {
    //     try {
    //         const response = await Api.post<IPluginNotificationSendResultDto>(
    //             `/companies/${companyId}/plugins/${bindingId}/notification/cost`,
    //             dto,
    //         );
    //         return response.data;
    //     } catch (e: any) {
    //         throw new DataLoadException(e);
    //     }
    // }

    public async clientCommunicationSendMessage(
        companyId: string,
        bindingId: string,
        dto: IPluginCommunicationSendMessageDto,
    ): Promise<IPluginCommunicationSendMessageResult> {
        try {
            const response = await Api.post<IPluginCommunicationSendMessageResult>(
                `/companies/${companyId}/plugins/${bindingId}/client-communication/send`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
